import { EllipseStencil } from "../../../core";

/**
 * Central Mind Map topic stencil.
 */
export class CentralTopicStencil extends EllipseStencil {
  public static typeName = 'CentralTopicStencil';
}
